import { Box, Button } from '@mui/material';
import { ChangeEvent, useRef } from 'react';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import { sharedStyles } from '../../utils/Style';

interface FileInputProps {
  file?: File;
  disabled?: boolean;
  onChange: (file?: File) => void;
}

export const FileInput = (props: FileInputProps) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleClick = () => {
    fileInputRef.current?.click(); // Manually trigger the file input click
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    props.onChange(e.target.files?.[0]);
  };

  return (
    <Box>
      <input
        accept='image/*'
        type='file'
        onChange={handleChange}
        ref={fileInputRef} // Attach the ref to the file input
        style={{ display: 'none' }}
        id='file-input'
      />
      <Button
        variant='contained'
        size='small'
        disabled={props.disabled}
        startIcon={<FolderOpenIcon />}
        sx={{ ...sharedStyles.buttonText }}
        onClick={handleClick}
      >
        Gözat
      </Button>
    </Box>
  );
};
